// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the page to the location hash, if any, after the component renders
 */
export function useScrollToHash() {
  const location = useLocation();

  useEffect(
    () => {
      const { hash } = location;
      if (hash) {
        const element = document.getElementById(hash.replace(/^#/, ""));
        if (element) {
          // there is an apparent a race condition between this effect and the necessary DOM updates
          // (particularly on mount), but adding a very short delay seems to help
          setTimeout(() => {
            element.scrollIntoView();
          }, 50);
        }
      }
    },
    // by reacting to the entire location we can capture clicks that don't actually change the hash,
    // e.g. if someone clicks a subsequent link after scrolling that points to the same hash
    [location],
  );
}
